<template>
  <div class="breadcrumbs-container">
    <div class="breadcrumbs" :class="overrideClass">
      <div class="bc" v-for="(breadcrumb, i) in generatedBreadcrumbs" :key="i">
        {{ getTitle(breadcrumb) }}
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "../../plugins/i18n";

export default {
  name: "breadcrumb",
  props: {
    breadcrumbsProp: {
      type: Array,
      required: false
    },
    overrideClass: {
      type: Object,
      required: false
    }
  },
  methods: {
    getTitle(breadcrumb) {
      return breadcrumb.translate ? i18n.t(breadcrumb.title) : breadcrumb.title;
    },
    onClick(breadcrumb) {
      if (breadcrumb.to) {
        this.$router.push({ name: breadcrumb.to, params: breadcrumb.params });
      }
      if (breadcrumb.callback) {
        breadcrumb.callback();
      }
    }
  },
  computed: {
    generatedBreadcrumbs() {
      if (this.breadcrumbsProp) return this.breadcrumbsProp;
      const routes = this.$route.fullPath.split("/");
      const params = { ...this.$route.params };
      routes.splice(0, 1);

      // const translateRegex = /stores|explore|sex|recommendations|clothing/;

      if (params.sex) {
        delete params.sex;
      }

      const breadcrumbs = routes.map(route => {
        return {
          title: `breadcrumb.titles.${route}`,
          // translate: translateRegex.test(route),
          translate: true,
          to: route,
          params: params
        };
      });
      return [
        {
          title: "breadcrumb.titles.home",
          translate: true,
          to: "Home",
          params: this.$route.params
        },
        ...breadcrumbs
      ];
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.breadcrumbs-container {
  position: relative;
  width: 100%;
  height: 40px;
  background-color: $gyra-grey-lightest;
}
.breadcrumbs {
  height: 20px;
  width: fit-content;

  margin-left: $gyra-margin-sides-mobile;
  @media (min-width: $gyra-breakpoint-lg) {
    margin-left: $gyra-margin-sides;
  }
  padding-top: 26px;

  display: flex;
  flex-direction: row;
}
.bc {
  display: flex;
  background-color: $gyra-grey-lightest;

  font-size: 13px;
  font-weight: 500;
  color: $gyra-grey-light;
  opacity: 0.5;
  /*cursor: pointer;*/

  &:hover {
    opacity: 0.8;
  }
  &:not(:last-child)::after {
    position: relative;
    content: ">";
    margin: 0 4px;
    font-size: 13px;
    font-weight: 500;
    color: $gyra-grey-light;
    opacity: 0.5;
  }
}
</style>
